// extracted by mini-css-extract-plugin
export default {"main":"Dividends_main__vJ65Z"};